// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type PointerDownIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from pointer-down.svg
 */
export default function PointerDownIcon(props: PointerDownIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="9"
      data-component="PointerDownIcon"
      {...props}
    >
      <path stroke="currentColor" d="m15.5 0-7 8-8-8" />
    </svg>
  );
}
